import routes from "common/routes";
import ITab, { TabValues } from "interfaces/Tab";

export const WORKOUT_REQUEST_OPTIONS = [
  "id",
  "facility.name",
  "horse.trainer.firstName",
  "horse.trainer.middleName",
  "horse.trainer.lastName",
  "date",
  "status",
  "created_on",
  "updated_on",
  "facility.id",
  "facility.backgroundColor",
  "facility.foregroundColor",
  "facility.strokeColor"
];
export const HORSE_EXAM_OPTIONS = [
  "id",
  "status",
  "result",
  "reasonId",
  "reason.description",
  "reason.code",
  "note",
  "riskLevel",
  "conclusion",
  "conclusionId",
  "completedDate",
  "isWorkoutExam",
  "isEntryExam",
  "isRaceDayExam",
  "facilityId",
  "facility.id",
  "facility.name",
  "facility.code",
  "facility.timezone",
  "assignedUserId",
  "assignedUser.id",
  "assignedUser.firstName",
  "assignedUser.lastName",
  "commentToTrainer.id",
  "commentToTrainer.body",
  "updatedOn",
  "workoutRequest",
  "workoutRequest.facility.name",
  "workoutRequest.facility.code",
  "workoutRequest.facility.timezone",
  "upcomingRaceEntry",
  "jogs:jogConditionId",
  "jogs:jogCondition",
  "jogs:customJogCondition",
  "jogs:jogScoreId",
  "jogs:jogScore",
  "jogs:jogInfoId",
  "jogs:jogInfo",
  "jogs:customJogInfo",
  "jogs:jogLimbId",
  "jogs:jogLimb",
  "jogs:customJogLimb",
  "examDetails:detailLasixCCsId",
  "examDetails:detailLasixCCs",
  "examDetails:detailStructureId",
  "examDetails:detailStructure",
  "examDetails:customDetailStructure",
  "examDetails:detailLimbId",
  "examDetails:detailLimb",
  "examDetails:customDetailLimb",
  "examDetails:detailLocationId",
  "examDetails:detailLocation",
  "examDetails:customDetailLocation",
  "examDetails:observationEntries:notes",
  "examDetails:observationEntries:detailConditionId",
  "examDetails:observationEntries:detailCondition",
  "examDetails:observationEntries:customDetailCondition",
  "examDetails:observationEntries:detailObservationId",
  "examDetails:observationEntries:detailObservation",
  "examDetails:observationEntries:customDetailObservation",
  "examDetails:observationEntries:detailSeverityId",
  "examDetails:observationEntries:detailSeverity"
];
export const VET_HORSE_GET_OPTIONS = [
  "birthday",
  "currentFacility.name",
  "currentFacility.code",
  "currentFacility.workout_required_days_off",
  "currentFacility.backgroundColor",
  "currentFacility.foregroundColor",
  "currentFacility.strokeColor",
  "barn.name",
  "barn.facility.name",
  "barn.facility.code",
  "barn.facility.foreground_color",
  "stallNumber",
  "dam_name",
  "last_race_date",
  "last_race_facility.code",
  "last_race_facility.name",
  "last_workout_date",
  "last_workout_facility.code",
  "last_workout_facility.name",
  "name",
  "breeder.name",
  "owner.first_name",
  "owner.last_name",
  "registration_number",
  "sire_name",
  "trainer.first_name",
  "trainer.middle_name",
  "trainer.last_name",
  "trainer.trainerNumber",
  "trainer.type",
  "color_description",
  "healthWatchStatus",
  "gender",
  "chip_number",
  "color",
  "dateOfDeath",
  "riskFactorShortDescriptions",
  "riskFactorsCount",
  "flagOnTrack",
  "flagOnTrack.flagOnTrackComment.body",
  "flagOnTrack.flagOnTrackComment.updatedOn",
  "flagOnTrack.flagOnTrackComment.updatedBy.firstName",
  "flagOnTrack.flagOnTrackComment.updatedBy.lastName",
  "lifetime.starts",
  "lifetime.wins",
  "lifetime.place",
  "lifetime.show"
];

export const vetTabsList: ITab[] = [
  {
    name: "Activity",
    value: TabValues.ACTIVITY,
    path: routes.horseDetailsActivity.path
  },
  {
    name: "Details",
    value: TabValues.DETAILS,
    path: routes.horseDetails.path
  },
  {
    name: "Comments",
    value: TabValues.COMMENTS,
    path: routes.horseDetailsComments.path
  }
];
